import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { chatbotApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export interface AdminConversationsParams {
  userId?: number;
  from?: Date;
  to?: Date;
  search?: string;
  hasNegativeFeedback?: boolean;
  page: number;
  pageSize: number;
}

export function useAdminConversations(params: AdminConversationsParams) {
  return useQuery({
    queryKey: queryKeys.chatAdmin.conversations(params),
    queryFn: ({ signal }) =>
      chatbotApiClient.listAllConversations(
        params.userId,
        params.from,
        params.to,
        params.search,
        params.hasNegativeFeedback,
        params.page,
        params.pageSize,
        toCancelToken(signal),
      ),
    placeholderData: keepPreviousData,
    meta: { errorContext: 'admin conversations' },
  });
}
